<section class="section">
<ul class="breadcrumb breadcrumb-style ">
<li class="breadcrumb-item">
<h4 class="page-title m-b-0">IDD Price Details</h4>
</li>
<li class="breadcrumb-item">
<a routerLink="/dashboard">
<i data-feather="home"></i></a>
</li>
<li class="breadcrumb-item active">IDD Price Details</li>
</ul>
<div class="section-body">
<div class="row">
<div class="col-12">
<div class="card card-primary">
<div class="card-header">
<h4>IDD Price Details</h4>

<div class="card-header-action">
<a  data-toggle="collapse"  class="btn btn-icon btn-info" href="#tableCollapse">
<i class="fas fa-minus"></i></a>
</div>

</div>
<div class="collapse show" id="tableCollapse">
<div class="card-body">
<div class="table-responsive">
<table class="table table-striped"  >








<thead>
<tr>

<th>IDD Price Details</th>
<!-- <th>Date</th> -->

</tr>
</thead>
<tbody>


<!-- <td>{{offset_count+i+1}}</td> -->
<!-- <td>{{l.date}}</td> -->
<!-- <td>
<div class="badge badge-success badge-shadow">&nbsp;&nbsp;</div>
</td> -->

<!-- <td>{{l.company_name}}</td> -->

<tr><td><a href='https://www.calncall.com/idd-rate-download' target='_blank'> SGD Rate details </a> </td></tr>

	<tr><td><a href='http://www.callacloud.com/idd-rates-download' target='_blank'> MYR Rate details  </a></td></tr>

	<tr><td><a href='http://www.callnclear.com/idd-rate-download/' target='_blank'> THB Rate details </a> </td></tr>








</tbody>





</table>
</div>






</div>
</div>
</div>
</div>
</div>
</div>
</section>